import { useEffect } from "react";
import { useResolvedPath } from "react-router-dom";
import styled from "styled-components";

import { API_CALLS } from "../../API/api_calls";
import { actions, useAppDispatch, useAppSelector } from "../../redux";
import { Header } from "./Header";
import { LayoutProps } from "./Layout";

export const Layout = ({ children }: LayoutProps.IProps) => {
  const dispatch = useAppDispatch();
  const pathname = useResolvedPath("");
  const { isArticleFullScreen } = useAppSelector((state) => state.common);

  useEffect(() => {
    dispatch(actions.common.setIsArticleFullScreen(false));
  }, [pathname.pathname, dispatch]);

  useEffect(() => {
    API_CALLS.ME.getSuggestedUsers();
  }, []);

  return (
    <Container>
      {!isArticleFullScreen && <Header />}
      <ChildrenContainer className="children-container">
        {children}
      </ChildrenContainer>
    </Container>
  );
};

const Container = styled.div`
  background: ${({ theme }) =>
    theme.Color.background.system["background-theme-2"].value};
  min-height: 100vh;
`;
const ChildrenContainer = styled.div`
  max-width: 1440px;
  margin: auto;
`;
